export default {
  home: {
    title: {
      title: 'Nook - App 管理器',
      desc: '清晰易用的屏幕使用时间管理与本地隐私保护',
      feature1: '通过 Apple 屏幕使用时间功能限制所选 App 的访问',
      feature2: '显示系统屏蔽页，或设置立即生效与每日限额',
      feature3: '全部屏幕使用时间管理功能均可免费使用'
    },
    func: {
      title: '四种清晰的 App 管理方式',
      desc1: '仅通过 Apple 家庭活动选择器选取 App',
      desc2: '随时应用、定时和解除您设置的限制',
      item1: {
        title: '应用访问限制',
        info: '阻止所选 App 启动',
        info2: '使用 Apple 公开的屏幕使用时间控制功能'
      },
      item2: {
        title: '仅屏蔽',
        info: '让所选 App 继续显示在设备上',
        info2: '打开时显示系统限制页面'
      },
      item3: {
        title: '每日限额',
        info: '立即应用限制，或达到每日使用阈值后应用',
        info2: '可选择在午夜自动解除限制'
      },
      item4: {
        title: '本地隐私',
        info: '可选 Pro 提供密码、Face ID 和替身专注计时器',
        info2: 'Pro 还提供替换 App 图标功能'
      }
    },
    inter: {
      title: '隐私优先的设计',
      info: '您的屏幕使用时间选择保留在设备本地',
      point1: 'Nook 只接收不透明的屏幕使用时间令牌，无法读取所选 App 的身份。',
      point2: '选项和计划仅存储在本地，供设备活动扩展执行。',
      point3: 'Nook 无需账户，也不会将屏幕使用时间活动上传到服务器。'
    },
    safe: {
      title: '清晰管理 App',
      title2: '屏幕使用时间功能免费开放',
      title3: '可选 Pro 提供本地隐私工具',
      download: '前往 App Store 下载'
    }
  },
  privacy: {
    title: '隐私政策',
    updated: '最后更新：2026 年 7 月 15 日',
    intro: 'Nook 是一款基于 Apple 屏幕使用时间框架的自我管理工具，无需注册账户。',
    data: {
      title: '1. 数据收集',
      info1: 'Nook 不收集或传输个人数据、位置信息、浏览记录或屏幕使用时间活动。',
      info2: 'App 和类别由 Apple 家庭活动选择器选取。Nook 只接收不透明令牌，无法识别您选择的具体 App。',
      info3: 'Nook 不包含广告、分析或第三方跟踪 SDK。'
    },
    storage: {
      title: '2. 本地存储',
      info1: '屏幕使用时间令牌和计划仅保存在 Nook 的 App Group 中，以便设备活动扩展执行您设置的限制。',
      info2: '可选密码和设置仅保存在设备本地，不会上传到服务器。'
    },
    permissions: {
      title: '3. 屏幕使用时间授权',
      info1: 'Nook 仅为提供用户主动选择的“应用访问限制”“仅屏蔽”、每日限额以及禁止安装/删除功能，请求个人屏幕使用时间授权。您可以在系统设置中撤销授权。'
    },
    purchase: {
      title: '4. App 内购买',
      info1: '可选终身 Pro 由 Apple 通过 StoreKit 处理。Nook 不会接收或存储银行卡信息。Pro 仅解锁本地隐私与个性化工具，全部屏幕使用时间管理功能保持免费。'
    },
    changes: {
      title: '5. 政策变更',
      info1: '当 Nook 的功能发生变化时，我们可能更新本政策。最新版本和生效日期会发布在本页面。'
    },
    contact: {
      title: '6. 联系我们',
      info1: '如有隐私相关问题，请联系：'
    }
  },
  agreement: {
    title: '用户协议',
    info1: 'Nook 由 Nook 授权给您（最终用户），仅可根据本协议的条款使用。',
    info2: '从 Apple 的软件分发平台（App Store）下载许可应用程序及其任何更新（在本协议允许的情况下），即表示您同意受 本协议的所有条款和条件，并且您接受本协议。 App Store 在本许可协议中称为“服务”',
    info3: '本协议的各方承认服务不是本协议的一方，并且不受与许可应用程序有关的任何条款或义务的约束，例如其保证、责任、维护和支持。 Nook（而非服务）对许可应用程序及其内容全权负责。',
    info41: '本协议不得规定与最新的',
    info42: 'Apple 媒体服务条款和条件',
    info43: '（“使用规则”）。 Nook 承认它有机会审查本协议与他们没有冲突。',
    info5: 'Nook 在通过服务购买或下载时，仅根据本协议的条款授权您使用。 许可方保留所有未明确授予您的权利。 Nook 将用于运行 Apple 操作系统（“iOS”和“iPadOS”）的设备。',
    item1: {
      title: '1.申请',
      info1: 'Nook（“许可应用程序”）是一款面向 iOS 和 iPadOS 的自我管理工具，使用 Apple 屏幕使用时间框架，让用户限制所选 App 的访问、显示系统限制页或设置每日限额。',
      info2: '许可应用程序并非为遵守特定行业法规（健康保险流通与责任法案 (HIPAA)、联邦信息安全管理法案 (FISMA) 等）而量身定制，因此如果您的互动将受到此类法律的约束 ，您不得使用此许可应用程序。 您不得以违反 Gramm-Leach-Bliley 法案 (GLBA) 的方式使用许可应用程序。'
    },
    item2: {
      title: '2. 许可范围',
      info1: '2.1 您被授予不可转让、非排他性、不可再许可的许可，可以在您（最终用户）拥有或控制的任何设备上安装和使用许可应用程序，并在使用规则允许的情况下， 与您（最终用户、购买者）关联的其他帐户可以通过家庭共享或批量购买访问和使用此类许可应用程序除外',
      info2: '2.2 本许可还将管辖许可方提供的许可应用程序的任何更新，这些更新替换、修复和/或补充第一个许可应用程序，除非为此类更新提供了单独的许可，在这种情况下，新的条款 以许可证为准。',
      info3: '2.3 您不得将许可应用程序共享或提供给第三方（除非在使用规则允许的范围内，并获得 Nook 的事先书面同意）、出售、出租、出借、 出租或以其他方式重新分发许可应用程序。',
      info4: '2.4 您不得对许可应用程序或其任何部分的源代码进行逆向工程、翻译、反汇编、集成、反编译、删除、修改、组合、创建衍生作品或更新、改编或尝试导出源代码（ 除非事先获得 Nook 的书面同意）。',
      info5: '2.5 您不得复制（除非本许可和使用规则明确授权）或更改许可应用程序或其部分。 根据本许可条款、使用规则以及适用于所用设备或软件的任何其他条款和条件，您只能在您拥有或控制备份保存的设备上创建和存储副本。 您不得删除任何知识产权声明。 您承认任何未经授权的第三方都不得随时访问这些副本。 如果您将设备出售给第三方，则必须先从设备中删除许可应用程序。',
      info6: '2.6 违反上述义务的行为以及此类侵权行为的企图可能会受到起诉和损害赔偿。',
      info7: '2.7 许可方保留修改许可条款和条件的权利。',
      info8: '2.8 本许可中的任何内容均不应解释为限制第三方条款。 使用许可应用程序时，您必须确保遵守适用的第三方条款和条件。'
    },
    item3: {
      title: '3. 技术要求',
      info1: '3.1 遵循苹果相关技术政策'
    },
    item4: {
      title: '4. 维护和支持',
      info1: '4.1 许可方全权负责为此许可应用程序提供任何维护和支持服务。 您可以通过此许可应用程序的 App Store 概览中列出的电子邮件地址联系许可方。'
    },
    item5: {
      title: '5. 责任',
      info1: '5.1 许可方对因违反本许可协议第 2 条规定的职责而造成的任何损害不承担任何责任。 为避免数据丢失，您需要在适用的第三方使用条款和条件允许的范围内使用许可应用程序的备份功能。 您知道，如果许可应用程序发生更改或操纵，您将无法访问许可应用程序。'
    },
    item6: {
      title: '6. 保修',
      info1: '6.1 许可方保证许可应用程序在您从 App Store 下载时不含间谍软件、特洛伊木马、病毒或任何其他恶意软件。',
      info2: '6.2 对于不能在设备上执行、未经授权修改、不当或过失地处理、与不适当的硬件或软件结合或安装、与不适当的附件一起使用的许可应用程序，无论是您自己还是 由第三方，或者如果存在影响许可应用程序可执行性的 Nook 影响范围之外的任何其他原因。',
      info3: '6.3 如果我们确认许可应用程序存在缺陷，Nook 保留通过解决缺陷或替代交付的方式来补救这种情况的选择。',
      info4: '6.4 如果许可应用程序未能遵守任何适用的保证，您可以通知服务商店运营商，您的许可应用程序购买价格将退还给您。 在适用法律允许的最大范围内，服务商店运营商对许可应用程序以及任何其他损失、索赔、损害、责任、费用以及因疏忽遵守任何 保修。',
      info5: '6.5 如果用户是企业家，则任何基于过错的索赔在向用户提供许可应用程序后十二 (12) 个月的法定时效期后到期。 法律规定的法定时效期限适用于作为消费者的用户。'
    },
    item7: {
      title: '7. 产品声明',
      info1: 'Nook 和最终用户承认，Nook（而非服务）负责解决最终用户或任何第三方与许可应用程序或最终- 用户拥有和/或使用该许可应用程序，包括但不限于：',
      info2: '(i) 产品责任索赔；',
      info3: '(ii) 任何关于许可应用程序不符合任何适用法律或法规要求的声明； 和',
      info4: '(iii) 根据消费者保护、隐私或类似立法引起的索赔，包括与您的许可应用程序对 HealthKit 和 HomeKit 的使用有关的索赔。'
    },
    item8: {
      title: '8. 法律合规',
      info1: '您声明并保证您不在受美国政府禁运或被美国政府指定为“支持恐怖分子”的国家/地区。 国家; 并且您未被列入任何美国政府的禁止或限制方名单'
    },
    item9: {
      title: '9. 联系方式',
      info1: '有关许可应用程序的一般查询、投诉、问题或索赔，请联系：'
    },
    item10: {
      title: '10. 终止',
      info1: '该许可在 Nook 或您终止之前一直有效。 如果您未能遵守本许可的任何条款，您在本许可下的权利将自动终止，而无需 Nook 的通知。 许可终止后，您应停止对许可应用程序的所有使用，并销毁许可应用程序的全部或部分副本。'
    },
    item11: {
      title: '11. 第三方协议条款和受益人',
      info1: 'Nook 声明并保证，Nook 在使用许可应用程序时将遵守适用的第三方协议条款。',
      info2: '根据“开发者最终用户许可协议最低条款说明”第 9 条，Apple 的子公司应是本最终用户许可的第三方受益人 协议以及——在您接受本许可协议的条款和条件后，Apple 将有权（并将被视为已接受该权利）作为第三方受益人对您执行本最终用户许可协议。'
    },
    item12: {
      title: '12. 知识产权',
      info1: 'Nook 和最终用户承认，如果任何第三方声称许可应用程序或最终用户对该许可应用程序的拥有和使用侵犯了第三方的权利的知识产权、Nook（而非服务）将全权负责调查、辩护、和解和解除或任何此类知识产权侵权索赔。'
    },
    item13: {
      title: '13. 适用法律',
      info1: '本许可协议受中国法律管辖，不包括其法律冲突规则。'
    },
    item14: {
      title: '14. 杂项',
      info1: '14.1 如果本协议任何条款无效或失效，不影响其余条款的有效性。 无效的条款将被以实现主要目的的方式制定的有效条款所取代。',
      info2: '14.2 附属协议、变更和修正仅在书面规定的情况下才有效。 前述条款只能以书面形式放弃。'
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/config/zh.js